import { gql } from '@apollo/client';
import CommonFragments from 'features/common/fragments';
import { partnerConsentFragment } from './fragments';

export const PARTNER_CONSENTS_SAVED = gql`
  subscription partnerConsentsSaved {
    partnerConsentsSaved {
      partnerConsents {
        ...partnerConsent
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
  ${partnerConsentFragment}
`;
